import { useField } from 'formik';
import { FormsGroup } from './FormsGroup';
import { useFormLabel } from './FormsI18nContext';
import { ColorPicker } from '../ColorPicker';
import { useEffect } from 'react';

export type FormsColorProps = {
  name: string;
  label?: string;
  initialValue?: string;
  required?: boolean;
  colors?: string[] | undefined;
};

export const FormsColor = ({
  name,
  label: labelOverride,
  required,
  colors,
  initialValue,
}: FormsColorProps) => {
  const [, { value }, { setValue }] = useField(name);
  const label = useFormLabel(name, labelOverride);

  useEffect(() => {
    if (value === undefined || value === null) {
      setValue(initialValue);
    }
  }, [initialValue, setValue, value]);

  return (
    <FormsGroup label={label} name={name} required={required} inline>
      <ColorPicker
        colors={colors}
        color={value}
        onChange={setValue}
      />
    </FormsGroup>
  );
};
